module.exports = __webpack_public_path__ + "static/stb_toast-messages-structure@2x-9bfa8f4b0584ed0362e7e08556d2b719.jpg";